﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import TKViewport from '@tk/basics/tk.viewport';
import TKBasketButton from '@/components/tk.basket.button';
import TKCarousel from '@/components/kdmz.carousel';
import TKContextMenu from '@/components/kdmz.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKArticleList from '@tk/components/tk.article.list';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFormValidator from '@/controls/kdmz.form.validator';
import TKCompareListLink from '@tk/components/tk.compare.list.link';
import TKCompareButton from '@tk/components/tk.compare.button';
import TKSelection from '@tk/controls/tk.selection';
import TKTable from '@tk/components/tk.table';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKQuickOrder from '@/components/kdmz.quick.order';
import KDMZFreitext from '@/components/kdmz.freitext';
import TKTabsTab from '@/components/kdmz.tabs.tab';
import TKFavoriteInfo from '@/components/tk.favorite.info';
import TKTabsAccordion from '@/components/kdmz.tabs.accordion';
import TKButtonDropdown from '@/controls/kdmz.button.dropdown';
import KDMZSearch from '@/components/kdmz.search';
import TKJumpNav from '@/components/tk.jump.nav';
import TKHeaderSearch from '@/components/tk.header.search';
import TKTracker from '@tk/components/tracker/tk.tracker';
// import TKFormTracker from '@tk/components/tk.form.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';

// Custom KDMZ elements
import KDMZFormElement from '@/components/kdmz.form.element';
import KDMZSelectBox from '@/components/kdmz.select.box';
import KDMZDialog from '@/components/kdmz.dialog';
import KDMZMinibasket from '@/components/kdmz.minibasket';
import KDMZClipboardButton from '@/components/kdmz.clipboard.button';
import KDMZSwitch from '@/components/kdmz.switch';
import KDMZFormIncreaser from '@/components/kdmz.form.increaser';
import KDMZQuestionExtension from '@/components/kdmz.class.question.extension';
import KDMZFileUploadArea from '@/controls/kdmz.file.upload.area';
import CustomValidation from '@/components/custom.validation';
import KDMZBasketButton from '@/components/kdmz.basket.button';
import KDMZAsyncFormResultlist from '@/components/kdmz.async.form.resultlist';
import KDMZPunchoutForm from '@/components/kdmz.punchout.form';
import KDMZAsyncPostField from '@/components/kdmz.async.post.field';
import KDMZVisibilityController from '@/components/kdmz.class.visibility.controller';
import KDMZAction from '@/components/kdmz.class.action';
import KDMZSpecialFormElement from '@/components/kdmz.class.special.form.element';
import KDMZPosTerminalList from '@/components/kdmz.posterminal.list';

import 'flatpickr/dist/flatpickr.min.css';
import 'tippy.js/dist/tippy.css';
import '@splidejs/splide/dist/css/splide.min.css';
import '@iconfont/iconfont/material-icons.css';
import '@scss/modules/general.scss';
import '@scss/modules/struct.scss';
import '@scss/modules/cv-ces.scss';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/core/dist/style.min.css';
import '@scss/modules/printorder.scss';
import '@scss/modules/verification.scss';

export default class General extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-form-element', constructor: KDMZFormElement },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-compare-list-link', constructor: TKCompareListLink },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-jump-nav', constructor: TKJumpNav },
            { name: 'tk-header-search', constructor: TKHeaderSearch },
            { name: 'tk-table', constructor: TKTable },
            { name: 'kdmz-select-box', constructor: KDMZSelectBox },
            { name: 'tk-dialog', constructor: KDMZDialog },
            { name: 'tk-minibasket', constructor: KDMZMinibasket },
            { name: 'kdmz-clipboard-button', constructor: KDMZClipboardButton },
            { name: 'kdmz-switch', constructor: KDMZSwitch },
            { name: 'kdmz-form-increaser', constructor: KDMZFormIncreaser },
            { name: 'kdmz-file-upload-area', constructor: KDMZFileUploadArea },
            { name: 'kdmz-question-extension', constructor: KDMZQuestionExtension },
            { name: 'tk-quick-order', constructor: TKQuickOrder },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'tk-custom-validation', constructor: CustomValidation },
            { name: 'kdmz-basket-button', constructor: KDMZBasketButton },
            { name: 'kdmz-async-form-resultlist', constructor: KDMZAsyncFormResultlist },
            { name: 'kdmz-freitext', constructor: KDMZFreitext },
            { name: 'kdmz-punchout-form', constructor: KDMZPunchoutForm },
            { name: 'kdmz-async-post-field', constructor: KDMZAsyncPostField },
            { name: 'kdmz-search', constructor: KDMZSearch },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'kdmz-visibility-controller', constructor: KDMZVisibilityController },
            { name: 'special-form-element', constructor: KDMZSpecialFormElement },
            { name: 'kdmz-posterminal-list', constructor: KDMZPosTerminalList },
            { name: 'kdmz-action', constructor: KDMZAction },
        ]);
    }
}

new General();
